import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Tabs } from "antd";
import AddShift from "./addShift";
import AllShifts from "./allShifts";
import { getAllShifts } from "../../redux/actions/shift";
import dayjs from "dayjs";
import { getAllAmbulanceMappings } from "../../redux/actions/ambulanceEmployeeMapping";
import { getAttendanceShifts } from "../../redux/actions/attendanceShifts";
import { getAllZonesApi } from "../../apis/districts";
import Attendance from "./Attendance";
import FilterPanel from "./filterPanel";
import MarkLiveAttendance from "../AttendanceDashboard/MarkLiveAttendance";

const ShiftManagement = () => {
  const dispatch = useDispatch();
  const allShifts = useSelector((state) => state.shift.data);
  const attendanceShift = useSelector((state) => state.attendanceShift.data);
  const isLoading = useSelector((state) => state.shift.isProcessing || state.attendanceShift.isProcessing);
  const [shiftPagination, setShiftPagination] = useState({ page: 1, pageSize: 10, total: 0 });
  const [attendancePagination, setAttendancePagination] = useState({ page: 1, pageSize: 10, total: 0 });
  const [shiftFilters, setShiftFilters] = useState({});
  const [attendanceFilters, setAttendanceFilters] = useState(() => {
    const user = JSON.parse(localStorage.getItem("currentUser"));
    const base = { fromDate: dayjs().format("YYYY-MM-DD"), toDate: dayjs().format("YYYY-MM-DD") };
    if (user?.tenant?.id) base.tenantId = user.tenant.id;
    else if (user?.role === "OPERATION_MANAGER" && user?.zone?.id) base.zoneId = user.zone.id;
    return base;
  });
  const [activeTab, setActiveTab] = useState("2");
  const [zones, setZones] = useState([]);
  const [currentUser] = useState(() => JSON.parse(localStorage.getItem("currentUser")));
  const isOpsManager = currentUser?.role === "OPERATION_MANAGER";
  const userZoneId = isOpsManager ? currentUser?.zone?.id : null;

  useEffect(() => {
    getAllZonesApi().then((res) => { if (res) setZones(res); });
    dispatch(getAllAmbulanceMappings())
    dispatch(getAllShifts({ page: shiftPagination.page - 1, size: shiftPagination.pageSize, ...shiftFilters }));
    dispatch(getAttendanceShifts({ page: attendancePagination.page - 1, size: attendancePagination.pageSize, ...attendanceFilters }));
  }, [dispatch, shiftPagination.page, shiftPagination.pageSize, attendancePagination.page, attendancePagination.pageSize, shiftFilters, attendanceFilters]);

  useEffect(() => {
    setShiftPagination(prev => ({ ...prev, total: allShifts.totalCount || 0 }));
    setAttendancePagination(prev => ({ ...prev, total: attendanceShift.totalCount || 0 }));
  }, [allShifts.totalCount, attendanceShift.totalCount]);
  const items = [
    // {
    //   key: "1",
    //   label: "All Shifts",
    //   children: (
    //     <AllShifts
    //       allShifts={allShifts.object || []}
    //       pagination={shiftPagination}
    //       onPageChange={(page) => setShiftPagination(prev => ({ ...prev, page }))}
    //       onPageSizeChange={(size) => setShiftPagination({ page: 1, pageSize: size, total: shiftPagination.total })}
    //       loading={isLoading}
    //     />
    //   ),
    // },
    {
      key: "2",
      label: "Attendance",
      children: (
        <Attendance
          attendanceShift={attendanceShift.object || []}
          pagination={attendancePagination}
          onPageChange={(page) => setAttendancePagination(prev => ({ ...prev, page }))}
          onPageSizeChange={(size) => setAttendancePagination({ page: 1, pageSize: size, total: attendancePagination.total })}
          loading={isLoading}
        />
      ),
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      {/* <AddShift /> */}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "1rem" }}>
        <MarkLiveAttendance
          onAttendanceMarked={() =>
            dispatch(
              getAttendanceShifts({
                page: attendancePagination.page - 1,
                size: attendancePagination.pageSize,
                ...attendanceFilters,
              })
            )
          }
        />
      </div>

      <FilterPanel
        filterType={activeTab === "1" ? "shift" : "attendance"}
        filters={activeTab === "1" ? shiftFilters : attendanceFilters}
        zones={zones}
        zoneId={userZoneId}
        zoneDisabled={isOpsManager}
        onFilter={(filters) => {
          if (activeTab === "1") {
            setShiftPagination(prev => ({ ...prev, page: 1 }));
            setShiftFilters(filters);
          } else {
            setAttendancePagination(prev => ({ ...prev, page: 1 }));
            const user = JSON.parse(localStorage.getItem("currentUser"));
            const scoped = { ...filters };
            if (user?.tenant?.id) scoped.tenantId = user.tenant.id;
            else if (user?.role === "OPERATION_MANAGER" && user?.zone?.id) scoped.zoneId = user.zone.id;
            setAttendanceFilters(scoped);
          }
        }}
      />

      <Tabs
        defaultActiveKey="2"
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items}
        destroyInactiveTabPane={false}
      />
    </div>
  );
};

export default ShiftManagement